import { api } from "../adapters/api"

const resource: string = "api/v1";

export const getAllCandidates: any = () => api.get(resource + "/candidates", {"Authorization": "Bearer " + localStorage.getItem("jwtToken")}).then((data: any) => data.json());

export const getCandidateById: any = (id: string) => api.get(resource + "/candidates/" + id, {"Authorization": "Bearer " + localStorage.getItem("jwtToken")}).then((data: any) => data.json());

export const getFavouriteCandidates: any = () => api.get(resource + "/candidates/favourite", {"Authorization": "Bearer " + localStorage.getItem("jwtToken")}).then((data: any) => data.json());

export const updateFavouriteCandidates: any = (id: string) => api.patch(resource + "/candidates/favourite/" + id, "", {'Content-type': 'application/json', "Authorization": "Bearer " + localStorage.getItem("jwtToken")});

export const getHistoryCandidates: any = () => api.get(resource + "/applications/history", {"Authorization": "Bearer " + localStorage.getItem("jwtToken")}).then((data: any) => data.json());

export const getActiveCandidates: any = () => api.get(resource + "/applications/active", {"Authorization": "Bearer " + localStorage.getItem("jwtToken")}).then((data: any) => data.json());

export const getCandidateByApplicationId: any = (id: string) => api.get(resource + "/applications/" + id, {"Authorization": "Bearer " + localStorage.getItem("jwtToken")}).then((data: any) => data.json());
